"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoaderTraceLogo = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const classnames_1 = __importDefault(require("classnames"));
const loader_traceLogo_style_1 = __importDefault(require("./loader.traceLogo.style"));
class LoaderTraceLogo extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.render = () => {
            const { classes, light } = this.props;
            return (jsx_runtime_1.jsxs("div", Object.assign({ className: classnames_1.default(classes.root, { [classes.rootLight]: light }), role: "none", "data-cy": "atomic-loader-trace-logo" }, { children: [jsx_runtime_1.jsx("em", {}, void 0),
                    jsx_runtime_1.jsx("em", {}, void 0),
                    jsx_runtime_1.jsx("em", {}, void 0)] }), void 0));
        };
    }
}
exports.LoaderTraceLogo = LoaderTraceLogo;
LoaderTraceLogo.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    light: prop_types_1.default.bool
};
LoaderTraceLogo.defaultProps = {
    light: false
};
exports.default = react_jss_1.default(loader_traceLogo_style_1.default)(LoaderTraceLogo);
//# sourceMappingURL=loader.traceLogo.js.map